export var version = '3.7.15';
//# sourceMappingURL=version.js.map